export const GALLERY = [
  {
    id: "lakefront",
    src: "/assets/gallery/lot-aerial-lakefront.webp",
    thumb: "/assets/gallery/lot-aerial-lakefront-md.webp",
    title: "Homesites Along the Lake Pontchartrain Levee",
    caption: "Aerial view looking toward Lake Pontchartrain — the open homesites sit directly beside the levee greenbelt with the lake beyond.",
  },
  {
    id: "overhead",
    src: "/assets/gallery/lot-aerial-overhead.webp",
    thumb: "/assets/gallery/lot-aerial-overhead-md.webp",
    title: "Woodlake Estates Neighborhood Context",
    caption: "The homesites within the established Woodlake Estates neighborhood, bordered by the levee greenbelt to the west.",
  },
  {
    id: "neighborhood",
    src: "/assets/gallery/lot-aerial-neighborhood.webp",
    thumb: "/assets/gallery/lot-aerial-neighborhood-md.webp",
    title: "The Verde Street Cul-de-Sac",
    caption: "Straight-down aerial of the collection — the Verde Street cul-de-sac, the street-front homesites along Platt Street and the levee-side property.",
  },
];
